export default __webpack_public_path__ + "static/media/sam_w640.efdcbaf5.jpeg";